import React, { Component } from 'react';
import { authenticate, firebaseApp } from '../firebase'
import { observer } from 'mobx-react';

const Signin = observer( class Signin extends Component {
	constructor(props) {
		super(props)
		this.state = {
			forgot: false,
			resetSent: false,
			error: {
				code:null,
				message: null
			}
		}

		this.handleEvent = this.handleEvent.bind(this)
		this.resetPass = this.resetPass.bind(this)
		this.signStat = this.signStat.bind(this)
	}

	componentDidMount(){
		// console.log('signin props', this.props.myStores);
	}

	handleEvent(e) {
		let { updateState } = this.props;
		let { myStores } = this.props;
		let { mainStore } = myStores;
		e.preventDefault()
		const formData = {}
		for(const field in this.refs){
			formData[field] = this.refs[field].value
		}
		e.target.reset();

		mainStore.signIn(formData.email,formData.password);

		// authenticate(formData.email,formData.password)
		// 	.then((response) => {
		// 		console.log('auth response',response);
		// 		this.setState({
		// 			email: formData.email,
		// 			password: formData.password,
		// 			error: {
		// 				code: null,
		// 				message: null
		// 			}
		// 		},() => {
		// 			// updateState(true,response.user);
		// 		})
		//
		// 	}).catch(error => {
		// 		console.log('auth error',error);
		// 		this.setState({error},() => {
		// 			// updateState(false,error);
		// 		});
		// 	})

	}

	resetPass(e){
		e.preventDefault()
		const formData = {}
		for(const field in this.refs){
			formData[field] = this.refs[field].value
		}
		e.target.reset()
		firebaseApp.auth().sendPasswordResetEmail(formData.email)
			.then(function(){
				this.setState({resetSent: true})
			}.bind(this))
			.catch(error => console.log('error sending password reset', error))
	}

	signStat(){
		this.setState({forgot: !this.state.forgot,resetSent: !this.state.resetSent})
	}

	render() {
		if(this.state.forgot){
			return (
				<div>
					<div className='container-fluid'>
						<div style={styles.container}>
						<img src={require('../images/funilylogo.png')} style={styles.image} />
						</div>
					<div className='col-md-4 col-md-offset-4' style={{marginTop: 30}}>
						<form onSubmit={this.resetPass}>
							<div className='form-group'>
							<input className='form-control text-center' type='email' name='email' ref='email' placeholder='Email' required />
							</div>
							<button className='btn btn-default btn-block' type='submit'>Reset my password</button>
						</form>
						{
							this.state.resetSent
								?
								<div style={{marginTop: 20}}>
								<p className='text-center'>Password reset was sent to your email.</p>
								<p className='text-center'>Go back to <a onClick={this.signStat} role='button'>signin</a> page</p>
								</div>
								: null
						}

					</div>
					</div>
				</div>
			)
		}
		return (
			<div className='container-fluid'>
				<div style={styles.container}>
					<img src={require('../images/funilylogo.png')} style={styles.image} />
				</div>
				<div className='col-md-4 col-md-offset-4' style={{marginTop: 30}}>
				<p className='text-center' style={{fontSize: 20}}>Partners | Admin Login</p>
					<form onSubmit={this.handleEvent}>
					<div className='form-group'>
					<input className='form-control text-center' type='email' name='email' ref='email' placeholder='Email' required />
					</div>
					<div className='form-group'>
					<input className='form-control text-center' type='password' name='password' ref='password' placeholder='Password' required />
					</div>
					{
						this.state.error.code ?
						<p style={{color:'red',textAlign:'center'}}>
							invalid email/password
						</p>
						: null
					}
					<button className='btn btn-default btn-block' type='submit'>Sign In</button>
					</form>
					<div style={{marginTop: 20}}>
					<a onClick={this.signStat} role='button'><p className='text-center'>Forgot Password?</p></a>
					</div>
					<div className='text-center' style={styles.aboutUs}>
						<a className='text-center' href='https://myfunily.com' target='_blank'>
						<button className='btn btn-default btn-block'>Learn more about us</button></a>
					</div>
				</div>

			</div>
		);
	}
})

const styles = {
	container: {
		display: 'flex',
		justifyContent: 'center',
		marginTop: '50px'
	},
	image: {
		height: '35%',
		width: '35%',
		borderRadius: '10px'
	},
	aboutUs: {
		paddingTop: 50,
		fontSize: 20
	}
}


export default Signin



// WEBPACK FOOTER //
// ./src/components/Signin.js